(() => {
  if (window.__esimCoverageMapLoaded) {
    if (typeof window.__esimCoverageMapScan === 'function') window.__esimCoverageMapScan();
    return;
  }
  window.__esimCoverageMapLoaded = true;

  const WORLD_URL = 'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json';
  const D3_GEO_URL = 'https://cdn.jsdelivr.net/npm/d3-geo@3/+esm';
  const TOPOJSON_URL = 'https://cdn.jsdelivr.net/npm/topojson-client@3/+esm';
  const SVG_NS = 'http://www.w3.org/2000/svg';

  const ISO = ['AD','AE','AF','AG','AI','AL','AM','AO','AR','AS','AT','AU','AW','AZ','BA','BB','BD','BE','BF','BG','BH','BI','BJ','BN','BO','BR','BS','BT','BW','BY','BZ','CA','CD','CF','CG','CH','CI','CL','CM','CN','CO','CR','CU','CV','CY','CZ','DE','DJ','DK','DM','DO','DZ','EC','EE','EG','EH','ER','ES','ET','FI','FJ','FK','FM','FO','FR','GA','GB','GD','GE','GF','GG','GH','GI','GL','GM','GN','GP','GQ','GR','GT','GU','GW','GY','HK','HN','HR','HT','HU','ID','IE','IL','IM','IN','IQ','IR','IS','IT','JE','JM','JO','JP','KE','KG','KH','KI','KM','KN','KP','KR','KW','KY','KZ','LA','LB','LC','LI','LK','LR','LS','LT','LU','LV','LY','MA','MC','MD','ME','MG','MH','MK','ML','MM','MN','MO','MP','MQ','MR','MS','MT','MU','MV','MW','MX','MY','MZ','NA','NC','NE','NG','NI','NL','NO','NP','NR','NZ','OM','PA','PE','PF','PG','PH','PK','PL','PM','PR','PS','PT','PW','PY','QA','RE','RO','RS','RU','RW','SA','SB','SC','SD','SE','SG','SI','SK','SL','SM','SN','SO','SR','SS','ST','SV','SX','SY','SZ','TD','TG','TH','TJ','TL','TM','TN','TO','TR','TT','TV','TW','TZ','UA','UG','US','UY','UZ','VA','VC','VE','VG','VI','VN','VU','WS','YE','ZA','ZM','ZW'];

  const aliases = {"bolivia":"BO","brunei":"BN","czech republic":"CZ","czechia":"CZ","ivory coast":"CI","cote d ivoire":"CI","congo":"CG","republic of the congo":"CG","democratic republic of the congo":"CD","dr congo":"CD","drc":"CD","eswatini":"SZ","swaziland":"SZ","iran":"IR","laos":"LA","moldova":"MD","north macedonia":"MK","macedonia":"MK","palestine":"PS","russia":"RU","south korea":"KR","north korea":"KP","syria":"SY","taiwan":"TW","tanzania":"TZ","turkey":"TR","turkiye":"TR","united kingdom":"GB","great britain":"GB","uk":"GB","united states":"US","united states of america":"US","usa":"US","vatican city":"VA","vietnam":"VN","cape verde":"CV","east timor":"TL","timor leste":"TL"};

  const worldAliases = {"united states of america":"US","dem rep congo":"CD","dem rep korea":"KP","central african rep":"CF","eq guinea":"GQ","w sahara":"EH","dominican rep":"DO","falkland is":"FK","fr s antarctic lands":"TF","bosnia and herz":"BA","s sudan":"SS","solomon is":"SB","timor leste":"TL","n cyprus":"CY","somaliland":"SO","kosovo":"XK","macedonia":"MK","czechia":"CZ","cote d ivoire":"CI","ivory coast":"CI","brunei":"BN","laos":"LA","vietnam":"VN","russia":"RU","iran":"IR","syria":"SY","moldova":"MD","south korea":"KR","north korea":"KP","tanzania":"TZ","bolivia":"BO","venezuela":"VE","swaziland":"SZ","eswatini":"SZ","the bahamas":"BS","bahamas":"BS"};

  const normalize = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/&/g, 'and').replace(/[^a-z0-9]+/g, ' ').trim();
  const cleanName = value => String(value).replace(/[\[\]"']/g, '').trim();
  const splitCountries = value => [...new Set(value.split(/[,;|\n]+/).map(item => cleanName(item)).filter(Boolean))];

  let nameToCode = null;
  const buildNameToCode = () => {
    if (nameToCode) return nameToCode;
    nameToCode = { ...aliases, ...worldAliases };
    if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
      const dn = new Intl.DisplayNames(['en'], { type: 'region' });
      ISO.forEach(code => {
        try { const name = dn.of(code); if (name && name !== code) nameToCode[normalize(name)] = code; } catch (e) { /* noop */ }
      });
    }
    return nameToCode;
  };

  const resolveCode = raw => {
    const trimmed = String(raw).trim();
    if (/^[A-Za-z]{2}$/.test(trimmed)) {
      const upper = trimmed.toUpperCase();
      if (ISO.includes(upper)) return upper;
    }
    return buildNameToCode()[normalize(trimmed)] || null;
  };

  const featureCode = feature => {
    const name = feature && feature.properties && feature.properties.name;
    if (!name) return null;
    return buildNameToCode()[normalize(name)] || null;
  };

  const setupChrome = (root, countries) => {
    const countEls = [root.querySelector('[data-country-count]'), root.querySelector('[data-dialog-count]')].filter(Boolean);
    countEls.forEach(el => { el.textContent = countries.length; });
    [root.querySelector('[data-inline-country-list]'), root.querySelector('[data-dialog-country-list]')].filter(Boolean).forEach(list => {
      list.innerHTML = '';
      countries.forEach(name => { const item = document.createElement('li'); item.textContent = name; list.append(item); });
    });
    const overlayList = root.querySelector('[data-overlay-list]');
    if (overlayList) {
      overlayList.innerHTML = '';
      countries.forEach(name => { const item = document.createElement('li'); item.textContent = name; overlayList.append(item); });
    }
    const dialog = root.querySelector('[data-country-dialog]');
    const openBtn = root.querySelector('[data-open-list]');
    const closeBtn = root.querySelector('[data-close-list]');
    if (dialog && openBtn && closeBtn) {
      openBtn.addEventListener('click', () => dialog.showModal());
      closeBtn.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    }
  };

  const setupInteractions = (root, viewport, content, countryCount) => {
    const DEFAULT_K = countryCount > 1 ? 1.9 : 0.7;
    const state = { k: DEFAULT_K, x: 0, y: 0 };
    const apply = () => { content.style.transform = `translate(${state.x}px, ${state.y}px) scale(${state.k})`; };
    const clampK = value => Math.min(6, Math.max(0.4, value));
    const setZoom = value => { state.k = clampK(Math.round(value * 100) / 100); if (state.k === DEFAULT_K) { state.x = 0; state.y = 0; } apply(); };
    root.querySelector('[data-zoom-in]')?.addEventListener('click', () => setZoom(state.k + 0.6));
    root.querySelector('[data-zoom-out]')?.addEventListener('click', () => setZoom(state.k - 0.3));
    root.querySelector('[data-zoom-reset]')?.addEventListener('click', () => setZoom(DEFAULT_K));

    let dragging = false; let startX = 0; let startY = 0; let originX = 0; let originY = 0;
    viewport.addEventListener('pointerdown', event => {
      if (event.target.closest('button')) return;
      dragging = true; startX = event.clientX; startY = event.clientY; originX = state.x; originY = state.y;
      viewport.setPointerCapture(event.pointerId); viewport.style.cursor = 'grabbing';
    });
    viewport.addEventListener('pointermove', event => {
      if (!dragging) return;
      state.x = originX + (event.clientX - startX);
      state.y = originY + (event.clientY - startY);
      apply();
    });
    const endDrag = () => { dragging = false; viewport.style.cursor = ''; };
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('wheel', event => {
      event.preventDefault();
      setZoom(state.k + (event.deltaY < 0 ? 0.4 : -0.4));
    }, { passive: false });

    apply();
  };

  const renderMap = async (root, countries) => {
    const svg = root.querySelector('[data-map-svg]');
    const landGroup = root.querySelector('[data-map-land]');
    const content = root.querySelector('[data-map-content]');
    const viewport = root.querySelector('[data-map-viewport]');
    const tooltip = root.querySelector('[data-map-tooltip]');
    if (!svg || !landGroup || !content || !viewport) return;

    const covered = new Set(countries.map(resolveCode).filter(Boolean));
    viewport.classList.add('is-loading');

    try {
      const [geoModule, topojson, world] = await Promise.all([
        import(D3_GEO_URL),
        import(TOPOJSON_URL),
        fetch(WORLD_URL).then(response => { if (!response.ok) throw new Error('world data failed'); return response.json(); })
      ]);

      const geo = topojson.feature(world, world.objects.countries);
      const features = geo.features;
      const W = 1000; const H = 560; const pad = 26;
      const highlighted = features.filter(feature => covered.has(featureCode(feature)));
      const fitTarget = highlighted.length ? { type: 'FeatureCollection', features: highlighted } : geo;
      const projection = geoModule.geoMercator().fitExtent([[pad, pad], [W - pad, H - pad]], fitTarget);
      const path = geoModule.geoPath(projection);

      svg.setAttribute('viewBox', `0 0 ${W} ${H}`);
      landGroup.innerHTML = '';

      const showTip = (event, name) => {
        if (!tooltip) return;
        const bounds = viewport.getBoundingClientRect();
        tooltip.textContent = name;
        tooltip.hidden = false;
        tooltip.style.left = `${event.clientX - bounds.left}px`;
        tooltip.style.top = `${event.clientY - bounds.top}px`;
      };
      const hideTip = () => { if (tooltip) tooltip.hidden = true; };

      features.forEach(feature => {
        const d = path(feature);
        if (!d) return;
        const code = featureCode(feature);
        const isCovered = code && covered.has(code);
        const el = document.createElementNS(SVG_NS, 'path');
        el.setAttribute('d', d);
        el.setAttribute('class', `esim-coverage-map__country${isCovered ? ' is-covered' : ''}`);
        if (isCovered) {
          const label = (feature.properties && feature.properties.name) || code;
          el.setAttribute('tabindex', '0');
          el.setAttribute('role', 'img');
          el.setAttribute('aria-label', `${label}: covered`);
          el.addEventListener('pointerenter', event => showTip(event, label));
          el.addEventListener('pointermove', event => showTip(event, label));
          el.addEventListener('pointerleave', hideTip);
          el.addEventListener('focus', () => { const rect = el.getBoundingClientRect(); showTip({ clientX: rect.left + rect.width / 2, clientY: rect.top }, label); });
          el.addEventListener('blur', hideTip);
        }
        landGroup.append(el);
      });

      setupInteractions(root, viewport, content, countries.length);
    } catch (error) {
      console.warn('eSIM coverage map failed to render:', error);
    } finally {
      viewport.classList.remove('is-loading');
    }
  };

  const init = root => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const countries = splitCountries(root.dataset.countries || '');
    setupChrome(root, countries);
    renderMap(root, countries);
  };

  const scan = () => { document.querySelectorAll('[data-esim-coverage-map]').forEach(init); };
  window.__esimCoverageMapScan = scan;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', event => {
    const root = event.target.querySelector('[data-esim-coverage-map]');
    if (root) init(root);
  });
})();
